<template>
  <div class="user-view">
    <Title>
      <h1>KISI Haus</h1>
      <h1>An-/Abmeldung</h1>
    </Title>
    <PersonList
      :persons="showPersons"
      :allPersons="$store.state.persons"
      :showAll="showAllPersons"
      hasSearchbar
      :actions="actions"
      searchbarMargin="140px"
      v-slot="{ person }"
    >
      <Person
        :person="person"
        :key="person.id"
        showPresence
        :action="personClickAction"
      />
    </PersonList>
  </div>
</template>

<script>
import Title from '@/components/Title.vue';
import PersonList from '@/components/person-list/PersonList.vue';
import Person from '@/components/person-list/Person.vue';

export default {
  name: 'UserView',
  components: {
    Person,
    PersonList,
    Title,
  },
  data: function() {
    return {
      showAllPersons: false,
      actions: [
        {
          label: 'Alle anzeigen',
          event: (action) => {
            this.showAllPersons = !this.showAllPersons;
            action.label = this.showAllPersons
              ? 'Weniger anzeigen'
              : 'Alle anzeigen';
          },
          icon: ['fas', 'users'],
        },
        {
          label: 'Bearbeiten',
          event: () => {
            if (this.$store.getters.prevRoutePath === '/edit') {
              this.$router.go(-1);
            } else {
              this.$router.push('/edit');
            }
          },
          icon: ['fas', 'user-edit'],
        },
      ],
      personClickAction: {
        event: (action, person) => {
          person.present = !person.present;
          this.$store.dispatch('updatePerson', { person });
        },
      },
    };
  },
  computed: {
    showPersons() {
      return this.$store.state.persons.filter((p) => p.expected || p.present);
    },
  },
};
</script>
